import { Helmet } from 'react-helmet-async';

const ContactPageHelmet = () => {
  return (
    <Helmet>
      {/* Title & Meta */}
      <title>Contact Us - Velocent Global Secure Logistics</title>
      <meta
        name='description'
        content='Get in touch with Velocent Global for secure logistics and valuables transportation. Contact our offices in Dubai, India, and Turkey for assistance. Email us at info@velocentglobal.com or support@velocentglobal.com.'
      />
      <meta
        name='keywords'
        content='Velocent Global contact, secure logistics support, Dubai office, India office, Turkey office, gold transport, cash transport, artwork transport, info@velocentglobal.com, support@velocentglobal.com'
      />

      {/* Open Graph */}
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://www.velocentglobal.com/contact-us'
      />
      <meta
        property='og:title'
        content='Contact Velocent Global - Secure Logistics Experts'
      />
      <meta
        property='og:description'
        content='Reach out to Velocent Global for secure logistics and transportation of gold, cash, and high-value assets. Offices located in Dubai, India, and Turkey. Contact us via info@velocentglobal.com or support@velocentglobal.com.'
      />
      <meta
        property='og:image'
        content='https://www.velocentglobal.com/assets/images/favicon.png'
      />
      <meta property='og:site_name' content='Velocent Global' />
      <meta property='og:locale' content='en_US' />

      {/* Canonical */}
      <link rel='canonical' href='https://www.velocentglobal.com/contact-us' />
    </Helmet>
  );
};

export default ContactPageHelmet;
